<template>
    <NoData />
</template>

<script>
    export default {
        name: 'footballTeamStats'
    }
</script>